import { enumValidator } from '#validation/common/validators';
import { FilespaceFormat } from '../constants';
export const filespaceFormatValidator = enumValidator({
    values: FilespaceFormat,
    requiredError: 'filespace.filespaceFormat.required',
    invalidValueError: 'filespace.filespaceFormat.invalid',
});
